module.exports = __webpack_public_path__ + "img/doubleCommission.6ec9b952.svg";